import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("AuthToken"); // Replace with your token logic
  return token ? children : <Navigate to="/" />;
};

export default PrivateRoute;